export const dataHooks = {
  chartPopover: 'sparklineChart-popover',
  dataContainer: 'sparklineChart-dataContainer',
};
